/**
 * IBAN Bank Mapping
 * 
 * Maps French bank codes (extracted from IBAN) to normalized bank names.
 * The bank code is found at position 4-8 (5 digits) of a French IBAN.
 * 
 * Example: FR76 3000 3011 6300 0560 6967 885
 *          ^^^^^ Bank code = 30003 = Société Générale
 */

/**
 * Mapping of French bank codes to normalized bank names
 * These names match the entries in bankColors.ts for logo display
 */
const FRENCH_BANK_CODES: Record<string, string> = {
  // BNP Paribas group
  '30004': 'BNP Paribas',
  '11729': 'BNP Paribas',
  '13078': 'BNP Paribas',
  '13088': 'BNP Paribas',
  '14898': 'BNP Paribas',
  '15198': 'BNP Paribas',
  '15408': 'BNP Paribas',
  '40198': 'BNP Paribas',
  '41919': 'BNP Paribas',
  '30958': 'BNP Paribas',
  '45190': 'BNP Paribas',
  '45418': 'BNP Paribas',
  '41329': 'BNP Paribas',
  '15668': 'BNP Paribas',
  '16078': 'BNP Paribas',
  
  // Société Générale group
  '30003': 'Société Générale',
  '12148': 'Société Générale',
  '13769': 'Société Générale',
  '15878': 'Société Générale',
  '15968': 'Société Générale',
  '17073': 'Société Générale',
  '45280': 'Société Générale',
  
  // Crédit Agricole group
  '10206': 'Crédit Agricole',
  '11006': 'Crédit Agricole',
  '11206': 'Crédit Agricole',
  '11306': 'Crédit Agricole',
  '11706': 'Crédit Agricole',
  '12006': 'Crédit Agricole',
  '12206': 'Crédit Agricole',
  '12406': 'Crédit Agricole',
  '12506': 'Crédit Agricole',
  '12906': 'Crédit Agricole',
  '13106': 'Crédit Agricole',
  '13210': 'Crédit Agricole',
  '13306': 'Crédit Agricole',
  '13506': 'Crédit Agricole',
  '13606': 'Crédit Agricole',
  '13906': 'Crédit Agricole',
  '14006': 'Crédit Agricole',
  '14406': 'Crédit Agricole',
  '14506': 'Crédit Agricole',
  '14706': 'Crédit Agricole',
  '14806': 'Crédit Agricole',
  '15673': 'Crédit Agricole',
  '16006': 'Crédit Agricole',
  '16106': 'Crédit Agricole',
  '16606': 'Crédit Agricole',
  '16706': 'Crédit Agricole',
  '16806': 'Crédit Agricole',
  '16906': 'Crédit Agricole',
  '17106': 'Crédit Agricole',
  '17206': 'Crédit Agricole',
  '17806': 'Crédit Agricole',
  '18106': 'Crédit Agricole',
  '18206': 'Crédit Agricole',
  '18306': 'Crédit Agricole',
  '18406': 'Crédit Agricole',
  '18506': 'Crédit Agricole',
  '18706': 'Crédit Agricole',
  '18807': 'Crédit Agricole',
  '19106': 'Crédit Agricole',
  '19206': 'Crédit Agricole',
  '19306': 'Crédit Agricole',
  '19406': 'Crédit Agricole',
  '19506': 'Crédit Agricole',
  '19606': 'Crédit Agricole',
  '19706': 'Crédit Agricole',
  '19806': 'Crédit Agricole',
  '19906': 'Crédit Agricole',
  '30006': 'Crédit Agricole',
  '16850': 'Crédit Agricole',
  '15898': 'Crédit Agricole',
  '31489': 'Crédit Agricole',
  '45360': 'Crédit Agricole',
  '15449': 'Crédit Agricole',
  
  // Crédit Mutuel / CIC group
  '10057': 'Crédit Mutuel',
  '10096': 'Crédit Mutuel',
  '10278': 'Crédit Mutuel',
  '11228': 'Crédit Mutuel',
  '11358': 'Crédit Mutuel',
  '11600': 'Crédit Mutuel',
  '11628': 'Crédit Mutuel',
  '11808': 'Crédit Mutuel',
  '11899': 'Crédit Mutuel',
  '11978': 'Crédit Mutuel',
  '13070': 'Crédit Mutuel',
  '13298': 'Crédit Mutuel',
  '13999': 'Crédit Mutuel',
  '14798': 'Crédit Mutuel',
  '14860': 'Crédit Mutuel',
  '15429': 'Crédit Mutuel',
  '15459': 'Crédit Mutuel',
  '15489': 'Crédit Mutuel',
  '15519': 'Crédit Mutuel',
  '15549': 'Crédit Mutuel',
  '15579': 'Crédit Mutuel',
  '15589': 'Crédit Mutuel',
  '15629': 'Crédit Mutuel',
  '15749': 'Crédit Mutuel',
  '15829': 'Crédit Mutuel',
  '15848': 'Crédit Mutuel',
  '15899': 'Crédit Mutuel',
  '15959': 'Crédit Mutuel',
  '16073': 'Crédit Mutuel',
  '16088': 'Crédit Mutuel',
  '16159': 'Crédit Mutuel',
  '16173': 'Crédit Mutuel',
  '16179': 'Crédit Mutuel',
  '17230': 'Crédit Mutuel',
  '30027': 'Crédit Mutuel',
  '30047': 'Crédit Mutuel',
  '30066': 'Crédit Mutuel',
  '30087': 'Crédit Mutuel',
  '30568': 'Crédit Mutuel',
  '41199': 'Crédit Mutuel',
  '45539': 'Crédit Mutuel',
  
  // LCL (Crédit Lyonnais)
  '30002': 'LCL',
  
  // Banque Populaire group
  '10107': 'Banque Populaire',
  '10207': 'Banque Populaire',
  '10807': 'Banque Populaire',
  '10907': 'Banque Populaire',
  '11307': 'Banque Populaire',
  '11907': 'Banque Populaire',
  '13507': 'Banque Populaire',
  '13607': 'Banque Populaire',
  '13807': 'Banque Populaire',
  '13907': 'Banque Populaire',
  '14607': 'Banque Populaire',
  '14707': 'Banque Populaire',
  '15007': 'Banque Populaire',
  '15607': 'Banque Populaire',
  '16607': 'Banque Populaire',
  '16707': 'Banque Populaire',
  '16807': 'Banque Populaire',
  '17607': 'Banque Populaire',
  '17807': 'Banque Populaire',
  '15958': 'Banque Populaire',
  '30077': 'Banque Populaire',
  
  // Caisse d'Épargne group
  '11315': 'Caisse d\'Épargne',
  '11425': 'Caisse d\'Épargne',
  '12135': 'Caisse d\'Épargne',
  '12225': 'Caisse d\'Épargne',
  '13135': 'Caisse d\'Épargne',
  '13335': 'Caisse d\'Épargne',
  '13485': 'Caisse d\'Épargne',
  '13825': 'Caisse d\'Épargne',
  '14265': 'Caisse d\'Épargne',
  '14445': 'Caisse d\'Épargne',
  '14505': 'Caisse d\'Épargne',
  '15135': 'Caisse d\'Épargne',
  '15998': 'Caisse d\'Épargne',
  '16275': 'Caisse d\'Épargne',
  '16485': 'Caisse d\'Épargne',
  '16705': 'Caisse d\'Épargne',
  '17515': 'Caisse d\'Épargne',
  '17695': 'Caisse d\'Épargne',
  '17865': 'Caisse d\'Épargne',
  '16248': 'Caisse d\'Épargne',
  
  // La Banque Postale
  '10011': 'La Banque Postale',
  '30041': 'La Banque Postale',
  '16178': 'La Banque Postale',
  
  // HSBC France
  '11379': 'HSBC',
  '30056': 'HSBC',
  '30118': 'HSBC',
  '30368': 'HSBC',
  '30938': 'HSBC',
  '11720': 'HSBC',
  '13888': 'HSBC',
  '14398': 'HSBC',
  '14408': 'HSBC',
  '16058': 'HSBC',
  '16553': 'HSBC',
  '45800': 'HSBC',
  
  // Boursorama / BoursoBank
  '40618': 'Boursorama',
  
  // Fortuneo
  '14518': 'Fortuneo',
  
  // ING
  '14559': 'ING',
  '11248': 'ING',
  '15518': 'ING',
  '30438': 'ING',
  
  // N26 (German bank, uses DE IBAN usually)
  
  // Revolut (Lithuanian bank, uses LT IBAN usually)
  
  // Qonto (French fintech)
  
  // Nickel
  
  // Monabanq
  '14690': 'Monabanq',
  
  // Hello Bank (BNP subsidiary)
  
  // Crédit Coopératif
  '42559': 'Crédit Coopératif',
  
  // Crédit du Nord
  '30076': 'Crédit du Nord',
  
  // Natixis / BPCE
  '30007': 'Natixis',
  '15930': 'Natixis',
  '16188': 'BPCE',
  '16238': 'Banque Populaire',
  '45600': 'Natixis',
  
  // Other major banks
  '30628': 'JP Morgan',
  '30748': 'Lazard',
  '30758': 'UBS',
  '30788': 'Neuflize OBC',
  '30588': 'Barclays',
  '24599': 'Barclays',
  '17789': 'Deutsche Bank',
  '43199': 'Crédit Foncier',
  '41189': 'BBVA',
  '41249': 'Bank of Tokyo',
  '41219': 'Bank of America',
  
  // AXA Banque
  '12240': 'AXA Banque',
  '12548': 'AXA Banque',
  '25080': 'AXA Banque',
  
  // Groupama Banque
  '14878': 'Groupama Banque',
  
  // Banque Palatine
  '40978': 'Banque Palatine',
  
  // Milleis (formerly Barclays France private banking)
  
  // Orange Bank
  '15938': 'Orange Bank',
};

/**
 * Extracts the bank code from a French IBAN
 * French IBAN format: FR76 BBBBB GGGGG CCCCCCCCCC KK
 * Where BBBBB is the bank code (positions 4-8, 0-indexed)
 * 
 * @param iban - The IBAN string (with or without spaces)
 * @returns The 5-digit bank code or null if invalid
 */
export function extractBankCodeFromIBAN(iban: string): string | null {
  // Remove spaces and convert to uppercase
  const cleanIBAN = iban.replace(/\s/g, '').toUpperCase();
  
  // Check if it's a French IBAN (starts with FR)
  if (!cleanIBAN.startsWith('FR') || cleanIBAN.length < 9) {
    return null;
  }
  
  // Extract bank code (positions 4-8, after "FR" + 2 check digits)
  return cleanIBAN.substring(4, 9);
}

/**
 * Gets the bank name from an IBAN
 * 
 * @param iban - The IBAN string
 * @returns The bank name or null if not found
 */
export function getBankNameFromIBAN(iban: string): string | null {
  const bankCode = extractBankCodeFromIBAN(iban);
  
  if (!bankCode) {
    return null;
  }
  
  return FRENCH_BANK_CODES[bankCode] || null;
}

/**
 * Checks if an IBAN is valid (basic format check)
 * 
 * @param iban - The IBAN string
 * @returns True if the IBAN appears valid
 */
export function isValidIBANFormat(iban: string): boolean {
  const cleanIBAN = iban.replace(/\s/g, '').toUpperCase();
  
  // French IBAN should be 27 characters
  if (cleanIBAN.startsWith('FR')) {
    return cleanIBAN.length === 27 && /^FR\d{25}$/.test(cleanIBAN);
  }
  
  // Basic check for other countries (2 letters + 2 digits + alphanumeric)
  return /^[A-Z]{2}\d{2}[A-Z0-9]+$/.test(cleanIBAN) && cleanIBAN.length >= 15 && cleanIBAN.length <= 34;
}
